import { IServerResponse } from '@/app-modules/server-communications';
import { BaseResponse } from '@/components/game/_domain/server/_base/base-response';
import { JsonWinnersData } from '@/components/game/_domain/server/json/prize/json-prize-data';
import { GameIdentity } from '@/components/game/_domain/models';
import { DefaultWinnersData } from '@/components/game/implementations/_json_defaults/_domain/models/prize';

class JsonWinnersResponse extends BaseResponse<JsonWinnersData> {
  constructor(
    private gameIdentity: GameIdentity) {
    super();
  }

  public filter(response: IServerResponse): boolean {
    return /"type":"winners"/g.test(response.Contents);
  }

  public map(response: IServerResponse): JsonWinnersData {
    const winners = JSON.parse(response.Contents);
    if (winners === null || winners.data === null) {
      throw new Error('Failed to map Json Winners Response');
    }

    return new DefaultWinnersData(winners.data.winners, winners.data.prizeEach, winners.data.prizeTotal, winners.data.now);
  }
}

export { JsonWinnersResponse };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/json/winners/json-winners-response.ts